import { render, staticRenderFns } from "./NewShopList.vue?vue&type=template&id=7664387c&scoped=true"
import script from "./NewShopList.vue?vue&type=script&lang=js"
export * from "./NewShopList.vue?vue&type=script&lang=js"
import style0 from "./NewShopList.vue?vue&type=style&index=0&id=7664387c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664387c",
  null
  
)

export default component.exports